export const initials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("") || "?";

// `pinned` is the always-visible "You" row at the bottom of the board; it gets
// the same highlight as an in-list current-user row plus a top divider.
const LeaderboardRow = ({ entry, pinned = false }) => {
  const highlight = pinned || entry.isCurrentUser;

  return (
    <div
      className="flex items-center gap-3 px-6 py-3 border-b border-light_gray"
      style={
        highlight
          ? { backgroundColor: "#f7f9ec", borderTop: "1px solid #b4c540" }
          : undefined
      }
    >
      <span className="w-6 text-center font-semibold text-secondary">
        {entry.rank ?? "—"}
      </span>

      <span
        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[11px] font-bold"
        style={{
          backgroundColor: entry.isCurrentUser ? "#b4c540" : "#e9e9e9",
          color: entry.isCurrentUser ? "#14141f" : "#575a6c",
        }}
      >
        {entry.isCurrentUser && !entry.name ? "You" : initials(entry.name)}
      </span>

      <span className="flex-1 truncate text-black">
        {entry.isCurrentUser ? "You" : entry.name}
        {entry.office && <span className="text-secondary"> · {entry.office}</span>}
      </span>

      <span className="font-semibold text-black">{entry.count}</span>
    </div>
  );
};

export default LeaderboardRow;
